import routerOptions0 from "/home/runner/_work/shadow/shadow/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@24.10.8_db0@0.3.2_eslint@9.38.0_jiti@2.6._36c4871e9ee6960990c90244cd6bbe8e/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  strict: true,
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}